module.exports = __webpack_public_path__ + "img/reviewer-C.a5774562.png";